import React from 'react';

//components
import Icon from '../icons/Icon';
import { IconLibrary } from '../../../interfaces/icon/IconLibrary';
import { ISimpleSearchInput } from '../../../interfaces/textInputs/ISimpleSearchInput';



const SimpleSearchInput = ({className, ariaLabel, placeholder, setSearchString, searchString, isDisabled} : ISimpleSearchInput ) => {
    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchString(event.target.value);
    };

    return (
        <div className={`simple-search-string-input-container ${className}`}>
            <Icon iconName={IconLibrary.SEARCH_GLASS} color='#9E9E9E' sizeInPx='12'/>

            <input 
                id="simple-search-input" 
                className="search-string-input" 
                type='text' 
                title="Search Input" 
                value={searchString} 
                placeholder={placeholder ?? "Search"} 
                onInput={handleInputChange} 
                disabled={isDisabled}
            />
            
            <label htmlFor="simple-search-input sr-only">{ariaLabel}</label>
        </div> 
    )
}

export default SimpleSearchInput